<template>
  <div class="relative"
       @mouseenter="showTooltip"
       @mouseleave="hideTooltip"
  >
    <div v-if="isVisible"
         class="tooltip-container-bottom"
    >
      <span>{{ text }}</span>
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'Tooltip',
  props: {
    text: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isVisible: false
    }
  },
  watch: {
    disabled (isDisabled) {
      if (isDisabled) this.isVisible = false
    }
  },
  methods: {
    showTooltip () {
      if (this.disabled) return
      this.isVisible = true
    },
    hideTooltip () {
      this.isVisible = false
    }
  }
}
</script>
